"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lib_1 = require("./lib");

var gravatar = function gravatar(props) {
  var email = props.email,
      options = props.options,
      children = props.children;
  return children(lib_1.getGravatarUrl(email, options));
};

exports.default = gravatar;